var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c("header", { staticClass: "card-header" }, [
      _c("p", { staticClass: "card-header-title" }, [
        _vm._v("Mover " + _vm._s(_vm.files.length) + " documentos"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-content" }, [
      _c("table", { staticClass: "table is-narrow is-fullwidth" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.filesCopy, function (file, i) {
              return _c("tr", { key: `file-${i}` }, [
                _c("td", [
                  _c("p", [
                    _vm._v(_vm._s(file.nombre) + "\n            "),
                    _vm.filesSucceded.includes(i)
                      ? _c("span", { staticClass: "has-text-success" }, [
                          _vm._v(" "),
                          _c("i", { staticClass: "fas fa-check-circle" }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filesFailed.includes(i)
                      ? _c("span", { staticClass: "has-text-danger" }, [
                          _vm._v(" "),
                          _c("i", { staticClass: "fas fa-times-circle" }),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.filesErrors[i]
                    ? _c("p", { staticClass: "has-text-danger is-size-7" }, [
                        _vm._v(_vm._s(_vm.filesErrors[i])),
                      ])
                    : _vm._e(),
                ]),
              ])
            }),
            _vm._v(" "),
            _vm.filesCopy.length == 0 ? _c("tr", [_vm._m(1)]) : _vm._e(),
          ],
          2
        ),
      ]),
    ]),
    _vm._v(" "),
    !_vm.isUploading && _vm.isDone
      ? _c("footer", { staticClass: "card-footer" }, [
          _c(
            "a",
            {
              staticClass: "card-footer-item",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$parent.close()
                },
              },
            },
            [_vm._v("Cerrar")]
          ),
        ])
      : _vm.isUploading
      ? _c("footer", { staticClass: "card-footer" }, [_vm._m(2)])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [_c("th", [_vm._v("Nombre")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "3" } }, [
      _c("i", [_vm._v("- No hay archivos para subir -")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass: "card-footer-item animated flash slow",
        attrs: { type: "button" },
      },
      [
        _c("i", { staticClass: "fas fa-sync fa-spin" }),
        _vm._v(" Moviendo documentos"),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }